import axios from 'axios';

export default function getErrorMessage(error: any): string {
  if (axios.isAxiosError(error)) {
    const dataMessage = error.response?.data?.message;
    return dataMessage ?? error?.message;
  } else if (error.error) return error.error;
  else if (error.data?.message) return error.data?.message;

  return 'An error occurred';
}
